<template>
    <div class="ps-page-body">
        <SeoHead :title="page.title || 'Terms of Service'" />

        <marketing-page-hero
            eyebrow="Legal"
            :title="page.title"
            :lead="data.updated_at ? `${__('Last updated')} ${data.updated_at}` : ''"
        />

        <section class="ps-page-body__section">
            <div class="container max-w-4xl">
                <div class="rounded-2xl border border-slate-200 bg-white p-6 md:p-8 leading-7 html prose prose-slate max-w-none" v-html="sanitizeHtml(page.content)" />
            </div>
        </section>
    </div>
</template>

<script>
import Layout from '@/Shared/Landing/Layout'
import MarketingPageHero from '@/Shared/Landing/MarketingPageHero'
import SeoHead from '@/Shared/SeoHead'
import sanitizeHtml from 'sanitize-html'

export default {
    layout: Layout,
    components: {
        MarketingPageHero,
        SeoHead,
    },
    props: {
        data: Object,
        title: String,
    },
    data() {
        return {
            page: JSON.parse(this.data.html),
        }
    },
    methods: {
        sanitizeHtml,
    },
}
</script>
